/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Hearts(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("./heart/star.gltf");

  useFrame((state) => {
    const t = state.clock.getElapsedTime();
    if (group.current) {
      // independent spin (parent group supplies the shared bob/sway)
      group.current.rotation.y = t * 0.7;
    }
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={nodes.star.geometry}
        material={materials["Yellow.030"]}
        rotation={[Math.PI / 2, 0, 0]}
      />
    </group>
  );
}

useGLTF.preload("./heart/star.gltf");
